var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tooltip"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.data.label))]),_c('div',{staticClass:"tip"},[_c('div',{staticClass:"label"},[_vm._v("账号: "+_vm._s(_vm.data.userName))]),_c('div',{staticClass:"label"},[_vm._v("归属部门: "+_vm._s(_vm.data.groupInfo[0].path))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }